module.exports = __webpack_public_path__ + "img/game_tiyu_yumaoqiu.d29c34c4.png";